// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/delete_deduction
 * Deletes a user deduction from payroll
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteDeductionResponseDados = boolean;

export type Payroll_DeleteDeductionResponse = ApiResponse<Payroll_DeleteDeductionResponseDados>;

registerResponseContract('Payroll_DeleteDeductionResponse', {})
